import React from 'react';

const AvikPalPR_EnzymeAD_Reactant_jl_95_From_2024_8_01_To_2024_8_31_Reviewers = () => {
  return (
    <div>
      <div className="discussion-sidebar-heading text-bold">
        Reviewers
      </div>
      
      <span className="css-truncate">
        {/* Reviewer 1 - wsmoses */}
        <p className="d-flex">
          <span
            className="d-flex min-width-0 flex-1 js-hovercard-left"
            data-hovercard-type="user"
            data-hovercard-url="/users/wsmoses/hovercard?bot=copilot-pull-request-reviewer"
            data-assignee-name="wsmoses"
          >
            <a
              className="no-underline"
              data-octo-click="hovercard-link-click"
              data-octo-dimensions="link_type:self"
              href="/wsmoses"
            >
              <img
                className="avatar mr-1 avatar-user"
                src="https://avatars.githubusercontent.com/u/1260124?s=40&v=4"
                width="20"
                height="20"
                alt="@wsmoses"
              />
            </a>
            <a
              className="assignee Link--primary css-truncate-target width-fit"
              data-octo-click="hovercard-link-click"
              data-octo-dimensions="link_type:self"
              href="/wsmoses"
            >
              <span className="css-truncate-target width-fit v-align-middle">wsmoses</span>
            </a>
          </span>

          <a
            id="review-status-wsmoses"
            className="flex-order-1"
            href="/EnzymeAD/Reactant.jl/pull/55/files/d5d75f3c9f14034bbc726944055b71791256f7e3"
            aria-labelledby="tooltip-69f0e36e-29eb-44d4-8eac-db71b2c8de21"
          >
            <span className="reviewers-status-icon text-center">
              <svg
                aria-hidden="true"
                height="16"
                viewBox="0 0 16 16"
                version="1.1"
                width="16"
                data-view-component="true"
                className="octicon octicon-comment color-fg-muted"
              >
                <path d="M1 2.75C1 1.784 1.784 1 2.75 1h10.5c.966 0 1.75.784 1.75 1.75v7.5A1.75 1.75 0 0 1 13.25 12H9.06l-2.573 2.573A1.458 1.458 0 0 1 4 13.543V12H2.75A1.75 1.75 0 0 1 1 10.25Zm1.75-.25a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h2a.75.75 0 0 1 .75.75v2.19l2.72-2.72a.749.749 0 0 1 .53-.22h4.5a.25.25 0 0 0 .25-.25v-7.5a.25.25 0 0 0-.25-.25Z"></path>
              </svg>
            </span>
          </a>
          {/* <tool-tip
            id="tooltip-69f0e36e-29eb-44d4-8eac-db71b2c8de21"
            for="review-status-wsmoses"
            popover="manual"
            data-direction="nw"
            data-type="label"
            data-view-component="true"
            className="sr-only position-absolute"
            aria-hidden="true"
            role="tooltip"
          >
            wsmoses left review comments
          </tool-tip> */}
        </p>

        {/* Reviewer 2 - Pangoraw */}
        <p className="d-flex">
          <span
            className="d-flex min-width-0 flex-1 js-hovercard-left"
            data-hovercard-type="user"
            data-hovercard-url="/users/Pangoraw/hovercard?bot=copilot-pull-request-reviewer"
            data-assignee-name="Pangoraw"
          >
            <a
              className="no-underline"
              data-octo-click="hovercard-link-click"
              data-octo-dimensions="link_type:self"
              href="https://github.com/Pangoraw"
            >
              <img
                className="avatar mr-1 avatar-user"
                src="https://avatars.githubusercontent.com/u/9824244?s=40&v=4"
                width="20"
                height="20"
                alt="@Pangoraw"
              />
            </a>
            <a
              className="assignee Link--primary css-truncate-target width-fit"
              data-octo-click="hovercard-link-click"
              data-octo-dimensions="link_type:self"
              href="https://github.com/Pangoraw"
            >
              <span className="css-truncate-target width-fit v-align-middle">Pangoraw</span>
            </a>
          </span>

          <a
            id="review-status-Pangoraw"
            className="flex-order-1"
            href="https://github.com/Pangoraw"
            aria-labelledby="tooltip-940352ed-6170-4076-b3bd-4747d2539df5"
          >
            <span className="reviewers-status-icon text-center">
              <svg
                aria-hidden="true"
                height="16"
                viewBox="0 0 16 16"
                version="1.1"
                width="16"
                data-view-component="true"
                className="octicon octicon-comment color-fg-muted"
              >
                <path d="M1 2.75C1 1.784 1.784 1 2.75 1h10.5c.966 0 1.75.784 1.75 1.75v7.5A1.75 1.75 0 0 1 13.25 12H9.06l-2.573 2.573A1.458 1.458 0 0 1 4 13.543V12H2.75A1.75 1.75 0 0 1 1 10.25Zm1.75-.25a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h2a.75.75 0 0 1 .75.75v2.19l2.72-2.72a.749.749 0 0 1 .53-.22h4.5a.25.25 0 0 0 .25-.25v-7.5a.25.25 0 0 0-.25-.25Z"></path>
              </svg>
            </span>
          </a>
          {/* <tool-tip
            id="tooltip-940352ed-6170-4076-b3bd-4747d2539df5"
            for="review-status-Pangoraw"
            popover="manual"
            data-direction="nw"
            data-type="label"
            data-view-component="true"
            className="sr-only position-absolute"
            aria-hidden="true"
            role="tooltip"
          >
            Pangoraw left review comments
          </tool-tip> */}
        </p>
      </span>
    </div>
  );
};

export default AvikPalPR_EnzymeAD_Reactant_jl_95_From_2024_8_01_To_2024_8_31_Reviewers;
